const getData = async (url) => {
  const subdomain = `https://api.lernplattform.morph3dbot.de${url}`;
  const response = await fetch(subdomain, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  });
  if(!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  } 
  return await response.json();
};


const getDataById = async (url, data) => {
  const subdomain = `https://api.lernplattform.morph3dbot.de${url}`;
  const response = await fetch(subdomain, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

const insertData = async (url, data) => {
  const subdomain = `https://api.lernplattform.morph3dbot.de${url}`;
  const response = await fetch(subdomain, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

const updateData = async (url, data) => {
  const subdomain = `https://api.lernplattform.morph3dbot.de${url}`;
  const response = await fetch(subdomain, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status} | ${response.statusText}`);
  }
  return await response.json();
}

const deleteData = async (url, data) => {
  const subdomain = `https://api.lernplattform.morph3dbot.de${url}`;
  const response = await fetch(subdomain, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response;
}

export { getData, getDataById, insertData, updateData, deleteData };

